import { render, staticRenderFns } from "./CarpoolingComingSoon.vue?vue&type=template&id=0f31f872&"
import script from "./CarpoolingComingSoon.vue?vue&type=script&lang=js&"
export * from "./CarpoolingComingSoon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports